var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57143 3H18.4286C19.1106 3 19.7646 3.27092 20.2468 3.75315C20.7291 4.23539 21 4.88944 21 5.57143V18.4286C21 19.1106 20.7291 19.7646 20.2468 20.2468C19.7646 20.7291 19.1106 21 18.4286 21H5.57143C4.88944 21 4.23539 20.7291 3.75315 20.2468C3.27092 19.7646 3 19.1106 3 18.4286V5.57143C3 4.88944 3.27092 4.23539 3.75315 3.75315C4.23539 3.27092 4.88944 3 5.57143 3V3Z",
    stroke: "#FFBA00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 15.8571L17.1427 12L13.2855 15.8379",
    stroke: "#FFBA00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4286 21L6.85714 9.42856L3 13.2857",
    stroke: "#FFBA00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 8.78573C17.2103 8.78573 17.7859 8.21009 17.7859 7.50001C17.7859 6.78993 17.2103 6.21429 16.5002 6.21429C15.7901 6.21429 15.2145 6.78993 15.2145 7.50001C15.2145 8.21009 15.7901 8.78573 16.5002 8.78573Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.2c5b3e3d862c5dc647f88f9481fedf13.svg";
export { ForwardRef as ReactComponent };